import { useTranslation } from 'react-i18next';
import { FilterSelect } from '@/shared/ui';
import { getServiceRequestStatusOptions } from '../model';
import type { ServiceRequestUrlState } from '../model';

interface ServiceRequestsFilterBarProps {
  filters: ServiceRequestUrlState;
  onFilterChange: (key: keyof ServiceRequestUrlState, value: string) => void;
}

export function ServiceRequestsFilterBar({ filters, onFilterChange }: ServiceRequestsFilterBarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-4 flex-wrap items-end">
      <FilterSelect
        label={t('request.status.label', 'Status')}
        value={filters.status || ''}
        onChange={(value) => onFilterChange('status', value)}
        options={getServiceRequestStatusOptions(t)}
      />
    </div>
  );
}
